import {
  ContextMenuItemData,
  UserGranularPermissions,
  WorkspaceAccess,
  WorkspaceRole,
} from '@nx-frontend/shared/types';
import { UnleashFeatures, UnleashFlags } from '@nx-frontend/shared/types';

export const getFilterMenuItemsByPrivileges =
  (
    canManageMembers: boolean,
    workspaceAccess: WorkspaceAccess,
    userGranularPermissions: UserGranularPermissions,
    unleashFlags: UnleashFlags
  ) =>
  (items: ContextMenuItemData[]): ContextMenuItemData[] => {
    const allowConditions: Record<string, boolean> = {
      'rename': workspaceAccess.role !== WorkspaceRole.READER,
      'duplicate': workspaceAccess.role !== WorkspaceRole.READER,
      'open-in-new-tab': true,
      'share': workspaceAccess.role !== WorkspaceRole.READER,
      'unshare': workspaceAccess.role !== WorkspaceRole.READER,
      'copy-link': true,
      'follow-updates': workspaceAccess.role !== WorkspaceRole.READER,
      'read-only': workspaceAccess.role !== WorkspaceRole.READER,
      'page-info': true,
      'delete': workspaceAccess.role !== WorkspaceRole.READER,
      'manage-members': canManageMembers,
      'move-to': workspaceAccess.role !== WorkspaceRole.READER && !userGranularPermissions.isLimitedInCurrentWorkspace,
      'copy-to': workspaceAccess.role !== WorkspaceRole.READER && !userGranularPermissions.isLimitedInCurrentWorkspace,
      'duplicate-folder':
        workspaceAccess.role !== WorkspaceRole.READER &&
        !userGranularPermissions.isLimitedInCurrentWorkspace &&
        unleashFlags[UnleashFeatures.DUPLICATE_FOLDER],
      'open-in-ai': workspaceAccess.role !== WorkspaceRole.READER,
      'page-with-tag': workspaceAccess.role !== WorkspaceRole.READER,
    };

    const itemsFiltered = items.filter((item, index) => {
      const prevItem = items[index - 1];
      const nextItem = items[index + 1];

      let result = true;
      if (item.id) {
        result = allowConditions[item.id];
        if (!nextItem) {
          if (!result) {
            if (prevItem?.isSeparator) {
              prevItem.isSeparator = false;
            }
          } else {
            if (item.isSeparator) {
              item.isSeparator = false;
            }
          }
        }
        if (!result) {
          return result;
        }
      }

      if (item.subMenu && item.subMenu.length) {
        item.subMenu = getFilterMenuItemsByPrivileges(
          canManageMembers,
          workspaceAccess,
          userGranularPermissions,
          unleashFlags
        )(item.subMenu); //deep filter
        return item.subMenu.length !== 0;
      }

      return true;
    });

    if (itemsFiltered.length && itemsFiltered[itemsFiltered.length - 1].isSeparator) {
      // turn off last item to be separator to make menu prettier
      itemsFiltered[itemsFiltered.length - 1].isSeparator = false;
    }

    return itemsFiltered;
  };
